import { useContext, useState } from "react";
import UiContext from "../../../../store/ui-context";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import { endOfMonth, format, startOfMonth } from "date-fns";

export const useAPIgetPackage = () => {
  const uiContext = useContext(UiContext);
  const { requestGetOne, requestGet, loading } = useAPIRequest();
  const [data, setData] = useState(null);
  const [error, setError] = useState({});

  const [filterValue, setFilterValue] = useState({
    search: "",
    bc_id: 0,
  });

  const fetchData = async ({ filter }) => {
    if (!validate()) {
      return;
    }
    // const newFilter =
    //   filter ??
    //   getFilter(filterValue) + "data_customer.data_bc.name:notin:JELIM,Janice;";
    const newFilter = filter ?? getFilter(filterValue);
    return requestGet({
      fullUrl: `/api/report`,
      params: {
        prefix: "remaining_packages",
        page: 1,
        take: 10000000,
        filter: newFilter,
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message, pagination }) => {
        setData({
          packages: _data,
          total_packages: sumAll(_data, "total"),
        });
      },
    });
  };

  const sumAll = (items, field) => {
    if (!Array.isArray(items) || items.length === 0) return 0;

    return items.reduce((sum, item) => {
      const value = item[field];
      return sum + (typeof value === "number" ? value : 0);
    }, 0);
  };

  const getFilter = (_filterValue) => {
    const filterArr = [];
    const newFilterValue = _filterValue ?? filterValue;
    if (newFilterValue.search) {
      filterArr.push(`data_product.name:contains:${newFilterValue.search}`);
    }

    if (newFilterValue.bc_id && newFilterValue.bc_id !== 0) {
      filterArr.push(`data_customer.bc_id:=:${newFilterValue.bc_id}`);
    }

    return filterArr.join(";");
  };

  const validate = () => {
    let isValid = true;

    return isValid;
  };

  return {
    data,
    setData,
    error,
    setError,
    fetchData,
    filterValue,
    setFilterValue,
    loading,
  };
};
